import React, { useEffect, useReducer, useContext } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, FormGroup, Input, Label } from "reactstrap";
import { MyNotificationSettingReducer, MyNotificationSettingState } from "../../reducer/MyAccountReducer";
import { getData } from "../../utils/localStorage";
import { GetAPI, PostAPI } from "../../API/APICalling";
import { GlobalContext } from '../../App';
import './MyAccount.css'


export default function MPManageNoti() {
    const globalContext = useContext(GlobalContext);
    const [state, dispatch] = useReducer(MyNotificationSettingReducer, MyNotificationSettingState)
    const history = useHistory();
    const session = getData('session');

    useEffect(() => {
        FnGetMyNotiSettings();
    }, []);


    const FnGetMyNotiSettings = async () => {
        const session = getData('session');
        if (!session) {
            globalContext.notifications('error', 'Your session has been expired, Please login again');
            history.push("/");
        }
        else {
            globalContext.loaderDispatch({ type: 'START_LOADING', payload: true });
            var result = await GetAPI(`myaccount/mynotisettings/${session.arnum}?email=${session.email}`);
            if (result) {
                globalContext.loaderDispatch({ type: 'STOP_LOADING' });
                if (result.error) {
                    dispatch({ type: 'ERROR' });
                    globalContext.notifications('error', result.error);
                }
                else if (result.data) {
                    dispatch({ type: 'GET_SUCCESS', payload: result.data })
                }
            }
        }

    }

    const FnUpdateMyNotiSettings = async (e, item) => {
        const session = getData('session');
        if (!session) {
            globalContext.notifications('error', 'Your session has been expired, Please login again.');
            history.push("/");
        }
        else {
            dispatch({ type: 'FIELD', id: item.code, value: e.target.checked });
            globalContext.loaderDispatch({ type: 'START_LOADING', payload: true });
            const data = state.data.find((i) => i.code === item.code)
            var result = await PostAPI(`myaccount/mynotisettings/${session.arnum}?email=${session.email}`, {...data, enabled: e.target.checked});
            if (result) {
                globalContext.loaderDispatch({ type: 'STOP_LOADING' });
                if (result.error) {
                    dispatch({ type: 'ERROR' });
                    globalContext.notifications('error', result.error);
                }
                else if (result.data) {
                    globalContext.notifications('success', 'Updated successfully');
                }
            }
        }
    }

    return (
        <>
            <div className="card">
                <div className="card-header text-left title-2">
                    Manage Notification
                </div>
                <div className="card-body">
                    {state.data?.map((item, index) => {
                        return <Row style={{ marginLeft: '0px' }} key={index}>
                            <Col md="12">
                                <FormGroup className="text-left">
                                    <Label check>
                                        <Input type="checkbox"
                                            checked={item.enabled}
                                            onChange={(e) => { FnUpdateMyNotiSettings(e, item) }}
                                        />
                                        {item.displaytext}
                                        <p class="description-mynoti">{item.descriptiontext}</p>
                                    </Label>
                                </FormGroup>
                            </Col>

                        </Row>
                    })}
                </div>
            </div>
        </>
    );
}
